import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { useAuth } from '../auth/useAuth'
import { AuthCard } from './AuthCard'
import styles from './ActivateLinkPage.module.scss'

/**
 * Shown when the URL carries an invite or login token. Nothing is exchanged
 * until the person clicks, so a mail scanner that renders the page cannot
 * spend the single-use link. A spent link clears the pending state; the app
 * then lands on the login page, which explains and offers a fresh link.
 * With a session already open, the person chooses: keep it, or use the link.
 */
export function ActivateLinkPage() {
  const { user, pendingLink, claimPendingLink, dismissPendingLink } = useAuth()
  const [busy, setBusy] = useState(false)
  const [unavailable, setUnavailable] = useState(false)
  const invite = pendingLink?.kind === 'invite'

  async function handleClaim() {
    setBusy(true)
    setUnavailable(false)
    if ((await claimPendingLink()) === 'unavailable') {
      setUnavailable(true)
      setBusy(false)
    }
  }

  return (
    <AuthCard
      title={invite ? 'Attiva il tuo account' : 'Accedi a Progetto Arca'}
      subtitle={
        user
          ? `Sei già connesso come ${user.email}. Puoi continuare con questo accesso o usare il link ricevuto via email.`
          : invite
            ? 'Un clic e Luma ti aspetta nella tua Inbox.'
            : 'Conferma per entrare con il link ricevuto via email.'
      }
      message={unavailable ? 'Non sono riuscita a completare l’accesso. Riprova tra qualche istante.' : null}
      messageIsError={unavailable}
    >
      <div className={styles.actions}>
        <Button disabled={busy} onClick={handleClaim} type="button">
          {busy ? 'Un momento...' : invite ? 'Attiva il mio account' : 'Accedi'}
        </Button>
        {user ? (
          <Button disabled={busy} onClick={dismissPendingLink} type="button" variant="outline">
            Continua come {user.email}
          </Button>
        ) : null}
      </div>
    </AuthCard>
  )
}
